import { observable, action, computed } from 'mobx'
import validate from 'validators/config'

export class FormField {

  @observable value
  @observable label
  @observable name
  @observable type
  @observable disabled = false
  @observable validations = {}
  @observable errors = []

  @computed
  get hasErrors() {
    return this.errors.length > 0
  }

  constructor({ value, validations, label, type = 'text', name, disabled = false }) {
    this.value = value
    this.label = label
    this.type = type
    this.name = name
    this.disabled = disabled
    this.validations = validations
  }

  @action.bound
  validate() {
    this.errors = validate.single(this.value, this.validations) || [];
  }

  @action.bound
  setValue(newValue) {
    this.value = newValue
    this.validate()
  }

}

export default function formField() {
  return new FormField(...arguments);
}



// WEBPACK FOOTER //
// ./src/helpers/formField.js